/* ux-ficha-compra.js — Simplit, 16/09/2026
 *
 * Martin: "deja la vista de producto de Simplit igual a la de Lhotse y que ofrezca lo de Recibelo
 * el mismo dia". Esta pieza pone en la ficha de Simplit las cinco cosas que Lhotse tenia y ella no:
 *
 *   1. El aviso de despacho el MISMO DIA, con cuenta regresiva (portado de Lhotse tal cual).
 *   2. "Impuestos incluidos. Envio calculado en el pago." bajo el precio.
 *   3. La cantidad AL LADO del boton, en una fila, en vez de en una linea propia arriba.
 *   4. El retiro gratis en tienda (seccion nativa del tema, que estaba apagada en la ficha).
 *   5. La tira de confianza + garantia y derecho a retracto.
 *
 * Por que todo por JS y no como bloques del tema
 * ----------------------------------------------
 * 🪤 Simplit tiene **85 templates de producto**, no uno. Agregar los bloques nativos habria que
 *    hacerlo en los 85 y cada template nuevo naceria sin ellos. Una pieza en theme.liquid cubre
 *    las 85 fichas de una y se revierte de una.
 *
 * Lo que se midio antes de escribir una linea (16/09, cotizando el carrito real de simplithome.cl)
 * ------------------------------------------------------------------------------------------------
 * ✅ Recibelo ⚡ (same day) SI cotiza en Simplit: con $159.980 a Santiago centro salen las cuatro
 *    opciones a $0 — Blue Express, Despacho gratis, Recibelo ⚡ y Recibelo 🕒. La promesa es real.
 * ✅ Retiro en tienda: **Bodega Quilicura** tiene pickup activo y plazo TWENTY_FOUR_HOURS. La
 *    seccion nativa /variants/<id>/?section_id=pickup-availability responde
 *    data-pick-up-available="true". No estaba ausente: estaba apagada en los templates.
 * 🪤 **Cambios: 30 dias, no 90.** Lhotse promete 90 en su tira; la politica publicada de Simplit
 *    (/policies/refund-policy) dice 30 dias para cambios y devoluciones, con garantia voluntaria
 *    de 30. Copiar el texto de Lhotse habria prometido el doble de lo que Simplit cumple.
 * 🪤 **Cuotas.** Simplit acepta Visa, Mastercard, Amex y Diners (iconos del footer). El 16/09 la
 *    tira decia "con tarjeta" porque no encontre con que sostener el "sin interes"; Martin
 *    confirmo ese mismo dia que el convenio es de la empresa y aplica a las tres tiendas, asi que
 *    quedo "Hasta 6 cuotas sin interes", igual que unionx.cl y Lhotse.
 * 🪤 **Recibelo no cubre toda la RM** (medido en Lhotse el 25/08: 35 de 52 comunas). Por eso el
 *    aviso dice "segun tu comuna" y nunca promete a una comuna concreta.
 * 🪤 **El checkout NO aplica el corte de las 14:00** — lo cumple la operacion, no el sistema. La
 *    barra superior del sitio ya lo promete ("Despacho SAME DAY, compras antes de las 14:00,
 *    Gran Santiago"), asi que esto lleva a la ficha una promesa que la tienda ya hacia.
 *
 * ⚠️ FERIADOS: la lista llega hasta diciembre de 2027. Si queda vieja, el peor caso es prometer
 * "hoy" un feriado. Los que se mueven por ley (29/06, 12/10, 31/10) van con la fecha ya corrida.
 */
(function () {
  'use strict';
  var CORTE = (function(){ var f = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago' }).format(new Date()); return f <= '2026-10-11' ? 13 : 14; })() /* Cyber 2026: corte 13:00 hasta el 11/10, después 14:00 (Andrés 24/09, Martin 01/10) */;                 // hora de corte que declara el sitio. Si bodega la cambia, aca.
  var CAMBIOS_DIAS = 30;          // lo que dice /policies/refund-policy de Simplit
  var FERIADOS = ['2026-09-18','2026-09-19','2026-10-12','2026-10-31','2026-11-01','2026-12-08',
    '2026-12-25','2027-01-01','2027-03-26','2027-03-27','2027-05-01','2027-05-21','2027-06-21',
    '2027-06-28','2027-07-16','2027-08-15','2027-09-17','2027-09-18','2027-10-11','2027-10-29',
    '2027-11-01','2027-12-08','2027-12-25'];
  var DIAS = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];

  function $(s, r) { return (r || document).querySelector(s); }

  /* ---------- 1. aviso de despacho el mismo dia ---------- */
  // 🪤 La hora sale SIEMPRE de America/Santiago con Intl, no de un offset fijo: Chile cambia de
  // horario y un -3 quemado se equivoca medio anio.
  function chile(d) {
    var f = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago', year: 'numeric',
      month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
    var p = {}; f.formatToParts(d || new Date()).forEach(function (x) { p[x.type] = x.value; });
    var h = parseInt(p.hour, 10); if (h === 24) h = 0;
    var fecha = p.year + '-' + p.month + '-' + p.day;
    return { fecha: fecha, h: h, m: parseInt(p.minute, 10),
             dow: new Date(fecha + 'T12:00:00Z').getUTCDay() };
  }
  var SABADOS_CYBER = ['2026-10-03', '2026-10-10']; /* Cyber 2026: estos sábados hay Same Day, los domingos no (Martin 01/10) */
  function habil(fecha, dow) { return SABADOS_CYBER.indexOf(fecha) > -1 || (dow >= 1 && dow <= 5 && FERIADOS.indexOf(fecha) < 0); }
  function proximoHabil(fecha) {
    var d = new Date(fecha + 'T12:00:00Z');
    for (var i = 0; i < 10; i++) {
      d.setUTCDate(d.getUTCDate() + 1);
      var f = d.toISOString().slice(0, 10);
      if (habil(f, d.getUTCDay())) return { fecha: f, dow: d.getUTCDay(), dias: i + 1 };
    }
    return null;
  }
  function textoHoy() {
    var c = chile();
    // Martin 07/10/2026: sin Same Day del 07 al 11/10, todo Next Day al mismo precio; el lunes vuelve solo.
    if (c.fecha >= '2026-10-07' && c.fecha <= '2026-10-11') return { cls: 'ux-hoy', ico: '📦',
      html: '<span class="ux-hoy__b">Recibe al día hábil siguiente</span> en Santiago, según tu comuna' };
    if (habil(c.fecha, c.dow) && c.h < CORTE) {
      var min = (CORTE - c.h) * 60 - c.m;
      var hh = Math.floor(min / 60), mm = min % 60;
      var falta = hh > 0 ? (hh + 'h ' + mm + 'min') : (mm + ' min');
      // Martin, 16/09: "saca lo que sale escrito con despacho Recíbelo". La bajada se va, pero el
      // matiz de cobertura NO: Recíbelo llega a 35 de las 52 comunas de la RM, así que sin
      // "según tu comuna" la ficha le prometería "hoy" a Colina o Melipilla, donde no llega.
      // Queda en la misma línea, en tres palabras.
      return { cls: 'ux-hoy ux-hoy--hoy', ico: '⚡',
        html: 'Compra en las próximas <span class="ux-hoy__b">' + falta + '</span> y te llega ' +
              '<span class="ux-hoy__b">hoy en Santiago</span>, según tu comuna' };
    }
    var n = proximoHabil(c.fecha);
    var cuando = !n ? 'el próximo día hábil' : (n.dias === 1 ? 'mañana' : 'el ' + DIAS[n.dow]);
    return { cls: 'ux-hoy', ico: '📦',
      html: 'Cómpralo ahora y <span class="ux-hoy__b">sale ' + cuando + '</span>' };
  }

  /* ---------- 3. la fila cantidad + boton ---------- */
  // La barra de envio gratis (ux-envio-caja, ya viva en el tema) se inserta antes de
  // .product__form-buttons cada vez que se pinta. Si el boton pasa a vivir dentro de la fila, la
  // barra se meteria DENTRO de la fila. Por eso el orden se re-asegura en cada pasada:
  //     aviso  ->  barra de envio  ->  [ cantidad | boton ]
  function fila() {
    var form = $('.product__form-buttons');
    var qty = $('.product-qty');
    if (!form || !qty) return null;
    var f = $('#ux-fila-compra');
    if (!f) {
      f = document.createElement('div');
      f.id = 'ux-fila-compra';
      f.className = 'ux-fila-compra';
      form.parentNode.insertBefore(f, form);
    }
    if (qty.parentNode !== f) f.appendChild(qty);
    if (form.parentNode !== f) f.appendChild(form);
    // el bloque de cantidad queda vacio: se esconde para no dejar un hueco
    var cajaQty = document.querySelector('.product__section-details__inner--product_quantity');
    if (cajaQty && !cajaQty.querySelector('.product-qty')) cajaQty.style.display = 'none';
    return f;
  }

  // 🩸 Lo que se rompio la primera vez: la barra de envio gratis se meta DENTRO de la fila.
  // Su script (ux-envio-producto-js, inline en theme.liquid) hace
  //     ancla.parentNode.insertBefore(caja, ancla)   con ancla = .product__form-buttons
  // y ese ancla ahora vive dentro de la fila ⇒ la barra entraba como un item flex entre la
  // cantidad y el boton, y el boton se salia de la pantalla en movil. Se vio en la captura en
  // vivo, no en la prueba por interceptacion: ahi mi script corria DESPUES y alcanzaba a
  // ordenarla, mientras que en vivo la barra se repinta sola tras el fetch a /cart.js.
  // ⇒ El orden no se deja al azar: se re-asegura en cada pasada Y con un vigilante que reacciona
  // apenas la barra se mueva. Orden buscado: aviso → barra de envio → [ cantidad | boton ].
  function ordena() {
    var f = fila();
    if (!f || !f.parentNode) return null;
    var padre = f.parentNode;
    var barra = document.getElementById('ux-envio-caja');
    if (barra && (f.contains(barra) || barra.parentNode !== padre || barra.nextSibling !== f))
      padre.insertBefore(barra, f);
    var caja = document.getElementById('ux-hoy-caja');
    var ancla = barra && barra.parentNode === padre ? barra : f;
    if (caja && (f.contains(caja) || caja.parentNode !== padre || caja.nextSibling !== ancla))
      padre.insertBefore(caja, ancla);
    return f;
  }

  var vigilante = null, pendiente = false;
  function vigila(f) {
    if (vigilante || !f || !f.parentNode || typeof MutationObserver === 'undefined') return;
    vigilante = new MutationObserver(function () {
      if (pendiente) return;                       // una sola pasada por frame: mover un nodo
      pendiente = true;                            // vuelve a disparar al observador
      requestAnimationFrame(function () { pendiente = false; ordena(); });
    });
    vigilante.observe(f.parentNode, { childList: true, subtree: true });
  }

  function pintaAviso() {
    var f = fila();
    if (!f) return;
    var caja = document.getElementById('ux-hoy-caja');
    if (!caja) { caja = document.createElement('div'); caja.id = 'ux-hoy-caja'; }
    if (!caja.parentNode) f.parentNode.insertBefore(caja, f);
    var t = textoHoy();
    caja.className = t.cls;
    caja.innerHTML = '<span class="ux-hoy__ico">' + t.ico + '</span><span>' + t.html + '</span>';
    ordena();
    vigila(f);
  }

  /* ---------- 2. impuestos incluidos ---------- */
  function pintaImpuestos() {
    if (document.getElementById('ux-impuestos')) return;
    var precio = $('#product-price') || $('.product__section-details__inner--product_info .price');
    if (!precio) return;
    var p = document.createElement('p');
    p.id = 'ux-impuestos';
    p.className = 'ux-impuestos';
    p.textContent = 'Impuestos incluidos. Envío calculado en el pago.';
    precio.parentNode.insertBefore(p, precio.nextSibling);
  }

  /* ---------- 4. retiro gratis en tienda (seccion nativa del tema) ---------- */
  // 🪤 El tema TIENE sections/pickup-availability.liquid y responde disponible; lo que faltaba era
  // el bloque en los templates. Se pide la seccion nativa por variante, asi el texto y el plazo
  // salen de la configuracion real de Shopify y no de un texto quemado que puede quedar viejo.
  var ultimaVariante = null;
  function pintaRetiro() {
    var campo = $('form[action*="/cart/add"] [name="id"]');
    var id = campo && campo.value;
    if (!id || id === ultimaVariante) return;
    ultimaVariante = id;
    fetch('/variants/' + id + '/?section_id=pickup-availability', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html || html.indexOf('data-pick-up-available="true"') < 0) return;
        // 🪤 El locale del tema esta en espaniol de Espania: dice "Recogida disponible en", que en
        // Chile nadie usa. Se corrige aca y no en locales/es.json para no tocar el resto del sitio
        // en el mismo cambio; si algun dia se arregla el locale, estas lineas dejan de encontrar
        // nada y no estorban.
        // Las variantes del locale son varias ("Recogida disponible en", "Recogida no disponible
        // actualmente en"...), asi que despues de los casos con nombre va un barrido general: la
        // palabra "Recogida" no debe quedar en ninguna forma.
        html = html.replace(/Recogida disponible en/g, 'Retiro gratis en')
                   .replace(/Recogida no disponible actualmente en/g, 'Retiro no disponible por ahora en')
                   .replace(/Recogida (?:actualmente )?no disponible en/g, 'Retiro no disponible en')
                   .replace(/Recogida/g, 'Retiro').replace(/recogida/g, 'retiro');
        var caja = document.getElementById('ux-retiro');
        if (!caja) {
          caja = document.createElement('div');
          caja.id = 'ux-retiro';
          caja.className = 'ux-retiro';
          var tras = document.querySelector('.product__section-details__inner--custom_liquid')
                  || document.getElementById('ux-fila-compra');
          if (!tras || !tras.parentNode) return;
          tras.parentNode.insertBefore(caja, tras.nextSibling);
        }
        caja.innerHTML = html;
        // 🩸 La seccion nativa trae DOS partes: el resumen y un modal con la direccion de la
        // bodega. El modal lo abre el JS de slideout del tema, que aca no corre (el HTML entra
        // por innerHTML) ⇒ quedaba desplegado en linea, con su X de cerrar y todo, comiendose
        // media pantalla. Se esconde por CSS y el enlace "Ver informacion de la tienda" pasa a
        // ser un desplegable propio: la direccion sigue estando, pero solo si la piden.
        caja.classList.remove('ux-retiro--abierto');
        var abre = caja.querySelector('.js-slideout-open');
        if (abre) abre.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          caja.classList.toggle('ux-retiro--abierto');
        }, true);
      })
      .catch(function () { /* sin retiro visible es peor que nada, pero no rompe la ficha */ });
  }

  /* ---------- 5. tira de confianza + retracto ---------- */
  function pintaConfianza() {
    if (document.getElementById('ux-confianza')) return;
    var ancla = document.getElementById('ux-retiro')
             || document.querySelector('.product__section-details__inner--custom_liquid')
             || document.getElementById('ux-fila-compra');
    if (!ancla || !ancla.parentNode) return;
    var d = document.createElement('div');
    d.id = 'ux-confianza';
    // 🥇 El markup es el de Lhotse, copiado de su DOM en vivo (Martin, 16/09: "eso debe ser igual
    // a Lhotse con los colores de Simplit"), no una version parecida: <ul> en grid de 3, cada item
    // con su SVG de 22px arriba, <b> de 12px/700 con el titulo y <i> de 11px/400 con la bajada.
    // Lo unico que cambia es el color del icono -- coral de Simplit en vez del gris de Lhotse -- y
    // los plazos, que son los de la politica de ESTA tienda (30 dias, no 90).
    d.innerHTML =
      '<ul class="ux-trust" role="list">' +
        '<li><a href="/pages/politica-de-envios"><span aria-hidden="true" class="ux-trust__i">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9.5 4.6 4.8A1.5 1.5 0 0 1 6 3.8h12a1.5 1.5 0 0 1 1.4 1L21 9.5"/><path d="M3 9.5h18v2a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0z"/><path d="M4.6 13.6V20h14.8v-6.4"/><path d="M9.8 20v-4.4h4.4V20"/></svg></span><b>Retiro GRATIS</b><i>en Bodega Quilicura</i></a></li>' +
        '<li><a href="/pages/cambios-y-devoluciones"><span aria-hidden="true" class="ux-trust__i">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8.2v7.6a1.5 1.5 0 0 1-.8 1.3l-7.5 4a1.5 1.5 0 0 1-1.4 0l-7.5-4A1.5 1.5 0 0 1 3 15.8V8.2a1.5 1.5 0 0 1 .8-1.3l7.5-4a1.5 1.5 0 0 1 1.4 0l7.5 4A1.5 1.5 0 0 1 21 8.2z"/><path d="M3.3 7.5 12 12l8.7-4.5M12 21v-9"/></svg></span><b>Cambios</b><i>hasta ' + CAMBIOS_DIAS + ' d\u00edas</i></a></li>' +
        // 🪤 Simplit no tiene /pages/medios-de-pago (404 el 16/09): este item va sin enlace, no a
        // una pagina que no existe.
        '<li><span class="ux-trust__item"><span aria-hidden="true" class="ux-trust__i">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="5" width="19" height="14" rx="2.2"/><path d="M2.5 9.6h19M6 15h3.4"/></svg></span><b>Hasta 6 cuotas</b><i>sin inter\u00e9s</i></span></li>' +
      '</ul>';  // 16/10/2026: Martin pidió sacar el acordeón "Garantía y derecho a retracto" de la ficha; la info sigue en la política y el pie.
    ancla.parentNode.insertBefore(d, ancla.nextSibling);
  }

  /* ---------- 6. la descripcion SIEMPRE abre cerrada ---------- */
  // Martin, 16/09: "la descripcion siempre debe aparecer cerrada cuando se abre un producto".
  // El `open` no viene del tema: esta escrito en el body_html de cada producto
  // (`<details open><summary>Descripcion</summary>`). El 16/09 se lo quitamos a los 198 que lo
  // tenian con scripts/cerrar_descripcion.py, pero un producto nuevo puede nacer con el otra vez
  // -- las descripciones las escribe otra persona. Esta guardia cierra el de la descripcion al
  // cargar, y SOLO ese: se acota al bloque product_description para no tocar el acordeon de
  // garantia ni ningun otro <details> del tema.
  var yaCerrado = false;
  function cierraDescripcion() {
    if (yaCerrado) return;
    var caja = document.querySelector('.product__section-details__inner--product_description');
    if (!caja) return;
    var ds = caja.querySelectorAll('details[open]');
    for (var i = 0; i < ds.length; i++) ds[i].open = false;
    yaCerrado = true;   // una sola vez: despues manda el cliente, si la abre se queda abierta
  }

  /* ---------- 6b. el parrafo suelto de arriba tambien va PLEGADO ---------- */
  // Martin, 23/09: "necesito que el texto del basurero tambien sea plegable y siempre parta
  // cerrado para que el cliente llegue mas directo al inpage".
  // 🪤 El basurero NO era una ficha sin acordeon: de las 160 activas, 155 traen su <details>.
  // Lo que pasa es que el body_html arranca con un PARRAFO SUELTO -- 706 caracteres en el
  // basurero -- y el <details> "Descripcion" empieza recien despues, con las Caracteristicas.
  // Ese parrafo suelto es lo unico que quedaba a la vista y lo que empujaba los banners del
  // inpage hacia abajo: medido el 23/09 en movil a 390px, la caja de la descripcion media 207 px
  // y el primer banner arrancaba en y=2055.
  // 🥇 En vez de inventar un SEGUNDO acordeon, el parrafo se MUEVE dentro del que ya existe:
  // queda un solo desplegable, cerrado, y el texto no se pierde -- sigue entero en el DOM, asi
  // que ni el SEO ni el JSON-LD cambian. Despues: caja 81 px y el banner en y=1929.
  // Si la ficha no trae ningun <details> (5 de 160 el 23/09), se le crea uno con el mismo rotulo.
  var introPlegada = false;
  function plegarIntro() {
    if (introPlegada) return;
    var caja = document.querySelector('.product__section-details__inner--product_description');
    if (!caja) return;
    var rte = caja.querySelector('.product__section--desc .rte') || caja.querySelector('.rte');
    if (!rte) return;
    var det = rte.querySelector(':scope > details');
    var sueltos = [];
    for (var i = 0; i < rte.childNodes.length; i++) {
      var n = rte.childNodes[i];
      if (n === det) break;
      // los saltos de linea que deja el Liquid no son contenido
      if (n.nodeType === 3 && !n.textContent.trim()) continue;
      sueltos.push(n);
    }
    if (!sueltos.length) { introPlegada = true; return; }   // ya venia todo dentro del acordeon
    if (!det) {
      det = document.createElement('details');
      var sum = document.createElement('summary');
      sum.textContent = 'Descripci\u00f3n';
      det.appendChild(sum);
      rte.appendChild(det);
    }
    // van DESPUES del <summary> y ANTES de lo que el <details> ya traia: el parrafo introduce
    // las caracteristicas, no las sigue.
    var anc = det.querySelector(':scope > summary');
    var ref = anc ? anc.nextSibling : det.firstChild;
    for (var j = 0; j < sueltos.length; j++) det.insertBefore(sueltos[j], ref);
    det.open = false;
    introPlegada = true;
  }

  /* ---------- 7. la categoria DENTRO de la columna, sobre el titulo (como Lhotse) ---------- */
  // Martin, 16/09: "la categoria arriba del titulo y el titulo mas grande como Lhotse".
  // Medido en las dos: en Lhotse la miga vive en la columna de info (x=869, justo sobre el titulo
  // en y=184) y el titulo es de 32px en TODOS los anchos. En Simplit la miga era una seccion
  // aparte a lo ancho de la pagina (x=0, w=1440) y el titulo 22px / 18,7px en movil.
  // La miga se MUEVE (no se duplica) y su seccion vacia se esconde.
  function migaArriba() {
    var col = document.querySelector('.product__section-details');
    var mig = document.getElementById('breadcrumb');
    if (!col || !mig) return;
    var caja = document.getElementById('ux-miga');
    if (!caja) {
      caja = document.createElement('div');
      caja.id = 'ux-miga';
      caja.className = 'ux-miga';
      col.insertBefore(caja, col.firstChild);
    }
    if (mig.parentNode !== caja) {
      caja.appendChild(mig);
      // la seccion original queda vacia: esconderla evita el hueco que dejaba arriba
      var sec = document.querySelector('.breadcrumb__section');
      if (sec) sec.style.display = 'none';
    }
  }

  /* ---------- 8. el carrusel de miniaturas, a la ALTURA de la foto principal ---------- */
  // Martin, 16/09: "se ve raro, la foto principal debe ser del tamanio del carrusel de la
  // izquierda". Con las 8 miniaturas sueltas el carrusel medía 794 px y la foto 550: la columna
  // izquierda sobresalia 240 px por debajo y se veia descolgada. En Lhotse las dos terminan casi
  // a la misma altura (foto 482 de alto, miniaturas hasta 963 desde 107).
  // ⇒ El alto del carrusel se iguala al de la foto y lo que no cabe queda con scroll, que es lo
  // que el tema hacia de origen (wrapper de 466 con overflow) antes de que el track roto lo
  // recortara a una sola miniatura.
  function altoCarrusel() {
    var sl = document.querySelector('.thumb-slider');
    var wr = document.querySelector('.thumb-slider .thumb-slider-wrapper');
    // 🩸 Hay que medir la IMAGEN, no su contenedor: el contenedor crece con el carrusel, asi que
    // igualarse a el se retroalimenta y no cambia nada. La primera vez medi el contenedor, dio
    // "difAlto 0" y la foto seguia terminando 320 px antes que las miniaturas.
    var foto = null, area = 0;
    var cand = document.querySelectorAll('.product__section-images img');
    for (var k = 0; k < cand.length; k++) {
      var b = cand[k].getBoundingClientRect();
      if (b.width > 200 && b.width * b.height > area) { area = b.width * b.height; foto = cand[k]; }
    }
    if (!sl || !wr || !foto) return;
    var h = Math.round(foto.getBoundingClientRect().height);
    if (h < 120) return;                       // aun no carga: no fijar una altura falsa
    sl.style.height = h + 'px';
    wr.style.height = h + 'px';
    wr.style.overflowY = 'auto';
    wr.style.overflowX = 'hidden';
  }

  function pinta() {
    try { altoCarrusel(); } catch (e) {}
    try { migaArriba(); } catch (e) {}
    try { plegarIntro(); } catch (e) {}
    try { cierraDescripcion(); } catch (e) {}
    try { pintaAviso(); } catch (e) {}
    try { pintaImpuestos(); } catch (e) {}
    try { pintaRetiro(); } catch (e) {}
    try { pintaConfianza(); } catch (e) {}
  }

  function arranca() {
    pinta();
    // la cuenta regresiva tiene que bajar sola, y a las 14:00 en punto el mensaje cambia sin que
    // nadie recargue
    setInterval(pinta, 60000);
    // la barra de envio gratis se dibuja tras un fetch a /cart.js y puede llegar despues
    setTimeout(pinta, 1200); setTimeout(pinta, 3500);
    // al cambiar de variante cambia el retiro
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'id' || e.target.closest('form[action*="/cart/add"]')))
        setTimeout(pinta, 120);
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca);
  else arranca();
})();
